import { styled } from "@mui/system";

export const StyleApplicationStatus = styled("div")(({ theme }) => ({
  display: "flex",
  justifyContent: "center",
  flexDirection: "column",
  alignItems: "center",
  width: "100%",
  borderRadius: 8,
  backgroundColor: "#ffffff",
  maxWidth: "650px",
  margin: "0 auto",
  "& > img": {
    width: "460px"
  },
  "& .message": {
    boxSizing: "border-box",
    maxWidth: "609px",
    textAlign: "center",
    color: "#373737",
    fontSize: 20,
    lineHeight: 1.5,
    "& > p": {
      marginBottom: "27px"
    }
  },
  "& .appStatusLink": {
    color: "#373737",
    border: "solid 1px #373737",
    padding: "3px 9px",
    fontSize: 14,
    margin: "5px",
    borderRadius: 21,
    display: "block",
    transition: "all 0.2s ease",
    textTransform: "inherit",
    "&:hover": {
      backgroundColor: "#373737",
      color: "#fff"
    }
  },
  "& .linkWrapper": {
    display: "flex",
    justifyContent: "center",
    alignItems: "center"
  }
}));

export const StyledApplicationErrorHeader = styled("header")(({ theme }) => ({
  position: "absolute",
  top: 30,
  zIndex: 12,
  "& svg": {
    width: "128px",
    height: "37px"
  },
  "& a": {
    display: "flex"
  },
  [theme.breakpoints.down("sm")]: {
    maxWidth: "270px"
  },
  [theme.breakpoints.up("sm")]: {
    left: 40
  },
  [theme.breakpoints.only("xs")]: {
    top: "20px",
    left: "16px"
  }
}));

export const StyledApplicationError = styled("div")(({ theme }) => ({
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  height: "100%",
  minHeight: "100vh",
  "& .appErrorLink": {
    background: "#1F1F1F",
    color: "#FFFFFF",
    width: "100%",

    borderRadius: "100px",
    fontSize: "24px",
    fontWeight: 400,
    padding: "10px 30px",
    fontFamily: "Rakbank Sans",
    textTransform: "inherit",
    [theme.breakpoints.up("sm")]: {
      width: "auto",
      marginRight: "16px",
      padding: "20px 40px"
    },
    "&:hover": {
      backgroundColor: "#373737",
      color: "#fff"
    }
  },
  "& .appErrorMultipleLink": {
    background: "#1F1F1F",
    color: "#FFFFFF",
    width: "80%",
    borderRadius: "25px",
    fontSize: "16px",
    fontWeight: 400,
    padding: "11px",
    fontFamily: "Rakbank Sans",
    textTransform: "inherit",
    [theme.breakpoints.up("sm")]: {
      width: "auto",
      marginRight: "16px",
      padding: "20px 40px",
      fontSize: "24px",
      borderRadius: "100px"
    },
    "&:hover": {
      backgroundColor: "#373737",
      color: "#fff"
    }
  },
  "& .appErrorStatus": {
    display: "flex",
    flexDirection: "column",
    padding: "24px",
    justifyContent: "center",
    width: "310px",
    height: "auto",
    background: "#FFFFFF",
    boxShadow: "0px 4px 20px rgba(0, 0, 0, 0.1)",
    borderRadius: "10px",
    [theme.breakpoints.up("sm")]: {
      padding: "40px",
      height: "auto",
      width: "788px"
    }
  },
  "& .errorMessage": {
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start"
  },
  "& .linkErrorWrapper": {
    display: "flex",
    alignItems: "flex-start",
    marginTop: "40px"
  },
  "& .title": {
    fontWeight: "500",
    fontSize: "20px",
    lineHeight: "28px",
    marginBottom: "8px",
    display: "flex",
    alignItems: "center",
    color: "var(--Color-Text-Primary-On-Light, #1F1F1F)",
    [theme.breakpoints.up("sm")]: {
      fontSize: "28px",
      lineHeight: "36px"
    }
  },
  "& .subTitle": {
    fontWeight: "400",
    fontSize: "20px",
    lineHeight: "28px",
    display: "flex",
    alignItems: "center",
    margin: "0px",
    color: "#757575"
  },
  "& .divider": {
    border: "1px solid #E6E6E6",
    width: "100%",
    marginTop: "40px",
    [theme.breakpoints.up("sm")]: {
      width: "708px"
    }
  },
  "& .info": {
    fontWeight: "400",
    fontSize: "16px",
    lineHeight: "28px",
    marginRight: "8px",
    color: "#757575",
    [theme.breakpoints.up("sm")]: {
      fontSize: "20px",
      lineHeight: "28px"
    },
    "& a, .externalLink": {
      color: "#0000FF",
      textDecoration: "underline",
      cursor: "pointer",
      "&:hover": {
        textDecoration: "none"
      }
    }
  }
}));
